import React, {useEffect, useState} from 'react';
import {useDispatch} from "react-redux";
import {ACTION_TYPES} from "../../app/actionTypes";
import {setActionPayload, setActionType} from "../../features/authorizationSlice";
import {useOutletContext} from "react-router-dom";

const ActivationToggle = ({cardId, isActive}) => {
    const [toggleClass, setToggleClass] = useState("toggle-input");

    const dispatch = useDispatch();
    const [onOpenQrAfterGenerate] = useOutletContext();

    useEffect(()=>{
        setToggleClass(isActive ? "toggle-input checked-toggle" : "toggle-input")
    },[isActive]);

    const handle_toggleChange = ()=>{
        dispatch(setActionType(ACTION_TYPES.ACTIVATE_DEACTIVATE_CARD));
        dispatch(setActionPayload({CardID: cardId}));

        onOpenQrAfterGenerate();
    }

    return (
        <div className="toggle row col-3">
            <div className="toggle-switch col-8">
                <div
                    id="toggle"
                    className={toggleClass}
                    onClick={() => {
                        handle_toggleChange();
                    }}
                />
                <label htmlFor="toggle" className="toggle-label"/>
            </div>
        </div>
    )
};

export default ActivationToggle;